import Decimal from 'decimal.js';

import { InstalmentType } from 'src/shared/enum/InstalmentType';

import { Term } from '../enum/Terms';

export class CreatePaymentPlanDto {
    readonly basePrice: number;

    readonly selectedStudents: number;

    readonly roomCode: string;

    readonly instalmentId: string;

    readonly instalmentType: InstalmentType;

    readonly selectedTerm: Term;

    readonly academicYear: string;

    readonly promotionId: string;

    readonly isRebooker: boolean;

    readonly fillerWeekEligible: boolean;

    readonly amend: boolean;

    readonly adminFee: boolean;

    readonly bookingId: string | null;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawPaymentPlan: any) {
        this.basePrice = new Decimal(rawPaymentPlan.basePrice).toNumber();
        this.selectedStudents = rawPaymentPlan.selectedStudents;
        this.roomCode = rawPaymentPlan.roomCode;
        this.instalmentId = rawPaymentPlan.instalmentId;
        this.instalmentType = rawPaymentPlan.instalmentType;
        this.selectedTerm = rawPaymentPlan.selectedTerm;
        this.academicYear = rawPaymentPlan.academicYear;
        this.promotionId = rawPaymentPlan.promotionId;
        this.isRebooker = rawPaymentPlan.isRebooker;
        this.fillerWeekEligible = rawPaymentPlan.fillerWeekEligible;
        this.amend = rawPaymentPlan.amend ?? false;
        this.adminFee = rawPaymentPlan.adminFee ?? false;
        this.bookingId = rawPaymentPlan.bookingId ?? null;
    }
}
